import React from 'react'
import { Modal, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'


import Container, { TitleBar, Content } from './styles'

const ModalCustom = (props) => {
  const { title, children, onClose, open } = props

  return (
    <Modal onClose={onClose} open={open}>
      <Container>
        <TitleBar>
          <h2>{title}</h2>
          {onClose && (
            <IconButton
              aria-label="close"
              onClick={onClose}
              className='close-button'
              size="large">
              <CloseIcon fontSize='inherit' />
            </IconButton>
          )}
        </TitleBar>
        <Content>
          {children}
        </Content>
      </Container>
    </Modal>
  )
}

export default ModalCustom
